import { Avatar as e } from "../Avatar/Avatar.mjs";
import { useState as t } from "react";
import { css as n, styled as r } from "styled-components";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/Message/Message.tsx
var o = r.div`
    display: flex;
    align-items: flex-end;
    gap: ${({ theme: e }) => e.spacing(1)};
    max-width: 80%;

    ${({ $variant: e }) => e === "outgoing" && n`
            flex-direction: row-reverse;
            align-self: flex-end;
        `}

    ${({ $variant: e }) => e === "incoming" && n`
            align-self: flex-start;
        `}
`, s = r.div`
    width: 32px;
    flex-shrink: 0;
`, c = (e, t, n) => {
	let r = n.radii.lg, i = n.radii.sm;
	return e === "single" || e === "first" ? t === "outgoing" ? `${r} ${r} ${i} ${r}` : `${r} ${r} ${r} ${i}` : e === "middle" ? t === "outgoing" ? `${r} ${i} ${i} ${r}` : `${i} ${r} ${r} ${i}` : t === "outgoing" ? `${r} ${i} ${r} ${r}` : `${i} ${r} ${r} ${r}`;
}, l = r.div`
    position: relative;
    padding: ${({ theme: e }) => e.spacing(1, 1.5)};
    border-radius: ${({ $groupPosition: e, $variant: t, theme: n }) => c(e, t, n)};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.normal};
    line-height: ${({ theme: e }) => e.typographyTokens.lineHeights.normal};
    word-break: break-word;
    white-space: pre-wrap;
    cursor: ${({ $clickable: e }) => e ? "pointer" : "default"};
    transition: opacity 0.15s ease;

    box-shadow: ${({ theme: e }) => e.shadows.soft};

    ${({ $variant: e, theme: t }) => e === "outgoing" ? n`
                  background-color: ${t.colors.primary};
                  color: ${t.colors.primaryForeground};
              ` : n`
                  /* Frosted glass incoming bubble — layers over the panel/gradient. */
                  background: rgba(255, 255, 255, 0.55);
                  backdrop-filter: blur(8px);
                  -webkit-backdrop-filter: blur(8px);
                  border: 1px solid ${t.glass.pillBorder};
                  color: ${t.colors.foreground};
              `}
`, u = r.span`
    display: block;
    margin-top: ${({ theme: e }) => e.spacing(.25)};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.normal};
    color: ${({ theme: e }) => e.colors.mutedForeground};

    ${({ $variant: e }) => e === "outgoing" ? n`
                  text-align: right;
              ` : n`
                  text-align: left;
              `}
`, d = r.div`
    display: flex;
    flex-direction: column;
`, f = ({ body: n, senderName: r, senderAvatar: c, timestamp: f, senderLabel: p, variant: m = "incoming", groupPosition: h = "single", showTimestamp: g = !1, showAvatar: _, className: v }) => {
	let [y, b] = t(!1), x = m === "incoming";
	return /* @__PURE__ */ a(o, {
		$variant: m,
		className: v,
		children: [x && (_ ?? (x && (h === "first" || h === "single")) ? /* @__PURE__ */ i(e, {
			src: c,
			alt: r,
			size: "sm"
		}) : /* @__PURE__ */ i(s, {})), /* @__PURE__ */ a(d, { children: [/* @__PURE__ */ i(l, {
			$variant: m,
			$groupPosition: h,
			$clickable: !!f,
			onClick: () => f && b((e) => !e),
			children: n
		}), f && (g || y) && /* @__PURE__ */ i(u, {
			$variant: m,
			children: p ? `${p} · ${f}` : f
		})] })]
	});
};
//#endregion
export { f as Message };
